const SELECTORS = {
  field: '.cumulative-achievements-business-unit-field',
  target: '.cumulative-achievements-business-unit-dropdown',
  selectionDropdown: '.ui.selection.dropdown'
};
const EVENT_NAMES = ['DOMContentLoaded', 'turbolinks:load', 'turbo:load'];
const BEFORE_CACHE_EVENT_NAMES = ['turbo:before-cache', 'turbolinks:before-cache'];
const BUSINESS_UNIT_DROPDOWN_WIDTH = '480px';
const SELECTION_DROPDOWN_CLASS = 'cumulative-achievements-business-unit-selection-dropdown';
const fieldObservers = new Map();

const applyWidthToDropdown = (dropdown) => {
  const alreadyApplied = (
    dropdown.style.width === BUSINESS_UNIT_DROPDOWN_WIDTH &&
    dropdown.style.minWidth === BUSINESS_UNIT_DROPDOWN_WIDTH &&
    dropdown.style.maxWidth === BUSINESS_UNIT_DROPDOWN_WIDTH &&
    dropdown.classList.contains(SELECTION_DROPDOWN_CLASS)
  );

  if (alreadyApplied) return;

  dropdown.style.width = BUSINESS_UNIT_DROPDOWN_WIDTH;
  dropdown.style.minWidth = BUSINESS_UNIT_DROPDOWN_WIDTH;
  dropdown.style.maxWidth = BUSINESS_UNIT_DROPDOWN_WIDTH;
  dropdown.classList.add(SELECTION_DROPDOWN_CLASS);
};

export function applyBusinessUnitDropdownWidth() {
  document.querySelectorAll(SELECTORS.target).forEach((selectOrDropdown) => {
    const field = selectOrDropdown.closest(SELECTORS.field);
    if (!field) return;

    const dropdown = field.querySelector(SELECTORS.selectionDropdown);
    if (!dropdown) return;

    applyWidthToDropdown(dropdown);
  });
}

const observeBusinessUnitDropdownFields = () => {
  if (typeof MutationObserver === 'undefined') return;

  document.querySelectorAll(SELECTORS.field).forEach((field) => {
    if (fieldObservers.has(field)) return;

    const observer = new MutationObserver(() => {
      applyBusinessUnitDropdownWidth();
    });

    observer.observe(field, { childList: true, subtree: true });
    fieldObservers.set(field, observer);
  });
};

export const disconnectBusinessUnitDropdownObservers = () => {
  fieldObservers.forEach((observer) => {
    observer.disconnect();
  });

  fieldObservers.clear();
};

export const initializeBusinessUnitDropdownWidth = () => {
  applyBusinessUnitDropdownWidth();
  observeBusinessUnitDropdownFields();

  [0, 100, 500].forEach((delay) => {
    window.setTimeout(applyBusinessUnitDropdownWidth, delay);
  });
};

EVENT_NAMES.forEach((eventName) => {
  document.addEventListener(eventName, initializeBusinessUnitDropdownWidth);
});

BEFORE_CACHE_EVENT_NAMES.forEach((eventName) => {
  document.addEventListener(eventName, disconnectBusinessUnitDropdownObservers);
});

export { BUSINESS_UNIT_DROPDOWN_WIDTH, SELECTION_DROPDOWN_CLASS };
